export const AppRoutes = {
  CHAMPION_OVERVIEW_1: "/lol/:language?/champions/:champion/build/:role?"
}